export default (() => {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('form.needs-validation.odin').forEach((form) => {
      form.addEventListener('submit', (event) => {
        if (form.checkValidity()) {
          const submitButton = form.querySelector('[type=submit]')
          submitButton.disabled = true
          submitButton.innerHTML =
            '<img src="https://c.tenor.com/I6kN-6X7nhAAAAAj/loading-buffering.gif" style="height:20px" />'
        } else {
          const invalidInput = form.querySelector(
            'input:invalid,select:invalid,textarea:invalid'
          )
          if (form.dataset.slient === 'true') {
            return false
          }
          const scrollIntoView = (el) => {
            const is_hide = el.style.display === 'none'
            if (is_hide) {
              el.style.display = 'block'
            }
            el.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'center',
            })
            el.focus()
            if (is_hide) {
              el.style.display = 'none'
            }
          }
          if (invalidInput) {
            const errorMessage =
              invalidInput.dataset.errorMessage ||
              form.dataset.errorMessage ||
              '請檢查輸入的資料'
            if (window.Swal) {
              window.Swal.fire({
                icon: 'error',
                title: form.dataset.errorTitle || '錯誤',
                text: errorMessage,
              }).then(() => {
                setTimeout(() => {
                  scrollIntoView(invalidInput)
                }, 500)
              })
            } else {
              alert(errorMessage)
              scrollIntoView(invalidInput)
            }
            event.preventDefault()
            event.stopPropagation()
          }
        }
      })
    })
  })
})()
